import { render, staticRenderFns } from "./ComissaoAtualizacao.vue?vue&type=template&id=e37acf76"
import script from "./ComissaoAtualizacao.vue?vue&type=script&lang=js"
export * from "./ComissaoAtualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports